import React, { Component, Fragment } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AlertItemStyles";
import { alertsActions } from "../_actions";
import moment from "moment";

export default class AlertItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: props.viewings.length !== 0
    };
  }

  toggleExpanded(id) {
    //const unix = Math.round(+new Date()/1000);
    //if (!this.state.expanded) this.props.dispatch(alertsActions.setViewing(id, unix))
    this.setState({ expanded: !this.state.expanded });
  }

  setCorrect(user, correct, id) {
    const unix = Math.round(+new Date() / 1000);
    this.props.dispatch(alertsActions.setCorrect(user, correct, id, unix));
  }

  render() {
    const {
      user,
      id,
      timestamp,
      assessments,
      level,
      name,
      text,
      icon,
      type,
      isDemoUser,
    } = this.props;
    const isToday = moment.unix(timestamp).isSame(moment(), "day"); //moment.unix(timestamp).format('ddd').charAt(0)

    return (
      <div id={`alert${id}`} className={css(styles.itemWrapper)}>
        <div className={css(styles.timeline)}>
          <span className={css(styles.date)}>
            {isToday ? "today" : moment.unix(timestamp).format("DD-MM-YY")}
          </span>
          <span className={css(styles.time)}>
            {moment.unix(timestamp).format("HH:mm")}
          </span>
        </div>
        <div
          className={css(
            styles.alert,
            isDemoUser && styles.borderBottom,
            this.state.expanded && styles.alertClosed
          )}
        >
          <div
            onClick={() => this.toggleExpanded(id)}
            className={css(
              styles.header,
              level === "Warning" && styles.warning,
              level === "Urgent" && styles.emergency,
              this.state.expanded && styles.headerClosed
            )}
          >
            <span className={css(styles.headerTitle)}>
              {level === "Warning"
                ? "Investigate"
                : level === "Urgent"
                ? "Urgent"
                : "Message"}
            </span>
            <span
              className={css(
                this.state.expanded
                  ? styles.headerToggleShow
                  : styles.headerToggleHide
              )}
            >
              {this.state.expanded ? "Show" : "Hide"}
            </span>
          </div>
          {!this.state.expanded && (
            <Fragment>
              <div className={css(styles.body)}>
                <div className={css(styles.bodyHeader)}>
                  <span className={css(styles.bodyTitle)}>
                    <img className={css(styles.icon)} src={icon} alt="" />
                    {name}
                  </span>
                  <div className={css(styles.type)}>
                    <span className={css(styles.typeName)}>{type}</span>
                    <span
                      className={css([
                        styles.typeIcon,
                        type === "Off" && styles.typeIconOff
                      ])}
                    >
                      Appliance is {type}
                    </span>
                  </div>
                </div>
                <span className={css(styles.bodyText)}>{text}</span>
              </div>
            </Fragment>
          )}
          {!this.state.expanded && !isDemoUser && !assessments.length && (
            <Fragment>
              <div className={css(styles.buttonContainer)}>
                <a
                  onClick={() => this.setCorrect(user, false, id)}
                  className={css(styles.incorrectButton)}
                >
                  Incorrect
                </a>
                <a
                  onClick={() => this.setCorrect(user, true, id)}
                  className={css(styles.correctButton)}
                >
                  Correct
                </a>
              </div>
            </Fragment>
          )}
          {!this.state.expanded && assessments.length ? (
            <Fragment>
              <div
                className={css(
                  assessments && assessments[0].correct
                    ? styles.correctContainer
                    : styles.incorrectContainer
                )}
              >
                {`Marked as ${
                  assessments && assessments[0].correct
                    ? "correct"
                    : "incorrect"
                }`}
              </div>
              <div className={css(styles.paddedContainer)}>
                <h2 className={css(styles.feedbackTitle)}>
                  Have more comments?
                </h2>
                <a
                  href={`/parents-home/alert-feedback/${id}`}
                  className={css(styles.buttonGreen)}
                >
                  Send Feedback
                </a>
              </div>
            </Fragment>
          ) : null}
        </div>
      </div>
    );
  }
}
